import React from 'react';
import { FadeInUp, SectionLabelLight, AccentLineLight, StaggerContainer, StaggerItem } from './AnimationWrappers';

const GOV_CLIENTS = [
  { name: 'Armasuisse — Eidgenossische Department Fur Verteidigung', desc: 'Federal Office for Defence Procurement', items: 'Combat uniforms, tactical outerwear, field equipment' },
  { name: 'SBB — Schweizerische Bundesbahnen', desc: 'Swiss National Railway Operator', items: 'Crew uniforms, hi-vis workwear, weather-resistant outerwear' },
  { name: 'AMZ — Kanton Zurich Sicherheitsdirektion', desc: 'Zurich Security Directorate', items: 'Police uniforms, tactical gear, ceremonial dress' },
  { name: 'EZV — Eidgenossische Zollverwaltung', desc: 'Federal Customs Administration', items: 'Border patrol uniforms, all-weather outerwear' },
];

const GovernmentSection = () => {
  return (
    <section id="government" data-testid="government-section" className="swiss-cross-bg relative overflow-hidden" style={{ background: '#1A2744', padding: '70px 0' }}>
      <div className="container-main relative z-10">
        <SectionLabelLight number="06" title="Government Portfolio" />
        <FadeInUp>
          <AccentLineLight />
        </FadeInUp>

        <div className="grid grid-cols-1 lg:grid-cols-2 items-start" style={{ gap: '50px' }}>
          <div>
            <FadeInUp>
              <h2 className="font-display text-white mb-6" style={{ fontSize: 'clamp(1.8rem, 4vw, 2.6rem)', fontWeight: 700, lineHeight: 1.1 }}>
                Trusted by the Swiss{' '}
                {/* Inline Swiss cross */}
                <span className="inline-flex items-center justify-center align-middle mx-1" style={{ width: '26px', height: '26px', background: '#C8102E', borderRadius: '3px', verticalAlign: 'middle' }}>
                  <span className="text-white font-light text-lg leading-none">+</span>
                </span>
                {' '}Confederation since 2004.
              </h2>
            </FadeInUp>
            <FadeInUp delay={0.1}>
              <p className="font-body mb-8" style={{ fontSize: '1.1rem', fontWeight: 300, color: 'rgba(255,255,255,0.75)', lineHeight: 1.85 }}>
                For over 25 years, we have been the trusted manufacturing partner for Switzerland's most demanding institutions. Every order, every audit, every specification — met without exception.
              </p>
            </FadeInUp>
            <FadeInUp delay={0.2}>
              <div className="flex gap-10 pt-5" style={{ borderTop: '1px solid rgba(255,255,255,0.15)' }}>
                <div>
                  <span className="font-display block text-white" style={{ fontSize: '1.8rem', fontWeight: 700 }}>25+</span>
                  <span className="font-mono" style={{ fontSize: '0.67rem', color: 'rgba(255,255,255,0.45)', textTransform: 'uppercase', letterSpacing: '0.12em' }}>Years of Orders</span>
                </div>
                <div>
                  <span className="font-display block text-white" style={{ fontSize: '1.8rem', fontWeight: 700 }}>100%</span>
                  <span className="font-mono" style={{ fontSize: '0.67rem', color: 'rgba(255,255,255,0.45)', textTransform: 'uppercase', letterSpacing: '0.12em' }}>Spec Compliance</span>
                </div>
              </div>
            </FadeInUp>
          </div>

          {/* Agency cards */}
          <StaggerContainer className="grid grid-cols-1" style={{ gap: '2px' }}>
            {GOV_CLIENTS.map((client, i) => (
              <StaggerItem key={i}>
                <div
                  data-testid={`gov-client-${i}`}
                  className="group transition-all duration-300"
                  style={{
                    background: 'rgba(255,255,255,0.05)',
                    borderLeft: '3px solid #C8102E',
                    padding: '18px 20px',
                  }}
                >
                  <h3 className="font-display text-white mb-1 group-hover:text-[#C8102E] transition-colors" style={{ fontSize: '1rem', fontWeight: 600 }}>
                    {client.name}
                  </h3>
                  <span className="font-mono block mb-2" style={{ fontSize: '0.6rem', color: 'rgba(255,255,255,0.35)', textTransform: 'uppercase', letterSpacing: '0.1em' }}>{client.desc}</span>
                  <p className="font-body" style={{ fontSize: '0.85rem', color: 'rgba(255,255,255,0.5)' }}>{client.items}</p>
                </div>
              </StaggerItem>
            ))}
          </StaggerContainer>
        </div>
      </div>
      <div className="section-number" style={{ color: 'rgba(255,255,255,0.03)' }}>06</div>
    </section>
  );
};

export default GovernmentSection;
